<template>
  <div ref="basicPortContent" class="basicPortContent">
    <Loading v-show="isLoading" ref="loading" class="loading" />
    <el-form
      ref="ruleForm"
      label-position="right"
      label-width="90px"
      :model="ruleForm"
      size="mini"
      class="ruleForm"
    >
      <div class="searhContent">
        <el-form-item
          prop="fliterTable"
          class="fliterTableb"
          style="display: inline-block; width: 200px; margin-bottom: 10px"
        >
          <el-input
            v-model="ruleForm.fliterTable"
            placeholder="请输入搜索内容"
            @input="handleInputClick"
          />
        </el-form-item>
        <el-button size="small" class="clickColor lr" @click="handleAddClick">
          新增
        </el-button>
      </div>
      <div class="tablePage">
        <el-table
          ref="multipleTables"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{
            backgroundColor: 'rgba(59, 175, 218, 1)',
            color: 'white',
            fontSize: '12px',
          }"
          :row-class-name="tabRowClassName"
          tooltip-effect="dark"
          @row-dblclick="handleCurrentChange"
        >
          <el-table-column prop="id" align="left" label="序号" width="50px">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column
            prop="portEn"
            label="港口英文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="portCn"
            label="港口中文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="portCode"
            label="港口五字码"
            align="left"
            :show-overflow-tooltip="true"
            min-width="110"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="terminal"
            label="码头"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop=""
            label="网站显示"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
            :formatter="getFormatPortFlag"
          />
          <el-table-column
            prop="areaCode"
            label="大航线"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="routeCn"
            label="航线"
            align="left"
            :show-overflow-tooltip="true"
            min-width="70"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="lon"
            label="经度"
            align="left"
            :show-overflow-tooltip="true"
            min-width="80"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="lat"
            label="纬度"
            align="left"
            :show-overflow-tooltip="true"
            min-width="80"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="portTimeZone"
            label="时区"
            align="left"
            :show-overflow-tooltip="true"
            min-width="70"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="countryEn"
            label="国家英文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="countryCn"
            label="国家中文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="cityEn"
            label="城市英文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="cityCn"
            label="城市中文"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="updateUser"
            label="操作人"
            align="left"
            :show-overflow-tooltip="true"
            min-width="100"
            :sortable="sortableState"
            :filters="[]"
          >
            <template slot-scope="scope">
              {{
                scope.row.updateUser ? scope.row.updateUser.toUpperCase() : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="left"
            :show-overflow-tooltip="true"
            min-width="142"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="updateTime"
            label="操作时间"
            align="left"
            :show-overflow-tooltip="true"
            min-width="142"
            :sortable="sortableState"
            :filters="[]"
          />
          <el-table-column
            prop="portCoverageNumber"
            label="港口覆盖率"
            align="center"
            :show-overflow-tooltip="true"
            min-width="110"
            :sortable="sortableState"
            :filters="[]"
          >
            <template slot-scope="scope">
              <span
                class="portCoverages"
                @click="handlePortCoverageClick(scope.$index, scope.row)"
                >{{ scope.row.portCoverage }}</span
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <noData />
          </template>
        </el-table>
      </div>
    </el-form>
    <!--分页-->
    <ThePagination
      v-if="isGangShow"
      ref="refPagination"
      :page-number="pageNumber"
      :attribute="paginationAttribute"
      class="refPagination"
    />
    <el-dialog
      v-if="dialogAddVisible"
      class="dialogAddVisible"
      :visible.sync="dialogAddVisible"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <basicPortsAdd
        :dialog-status="dialogStatus"
        :tables-row="tablesRow"
        @handleStatus="handleStatus"
        @handleClose="handleClose"
      />
    </el-dialog>

    <el-dialog
      v-if="dialogPortCoverageVisible"
      class="dialogPortCoverageVisible"
      :visible.sync="dialogPortCoverageVisible"
      width="660px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <portCoverage
        :table-coverage-row="tableCoverageRow"
        @handlePortCoverageClose="handlePortCoverageClose"
      />
    </el-dialog>
  </div>
</template>

<script>
import ThePagination from '@/components/ThePagination/ThePagination.vue'
import Loading from '@/components/Loading/outLoading.vue'
import basicPortsAdd from './basicPortsAdd.vue'
import portCoverage from './portCoverage.vue'
import noData from '@/components/noData/index.vue'
import { debounce } from 'lodash'
export default {
  inject: ['reload'],
  components: {
    ThePagination,
    basicPortsAdd,
    portCoverage,
    Loading,
    noData,
  },
  data() {
    return {
      isLoading: true,
      sortableState: true,
      dialogStatus: '',
      tablesRow: {},
      tableCoverageRow: {},
      isGangShow: true,
      //新增
      dialogAddVisible: false,
      //港口覆盖率
      dialogPortCoverageVisible: false,
      ruleForm: {
        fliterTable: '',
      },
      tableData: [],
      // tableDataEnd : [],
      // 引用 ThePagination组件
      refPagination: {},
      // 为 ThePagination组件 属性赋值
      paginationAttribute: {
        handleChange: this.handleChange,
      },
      //分页的默认状态
      pageNumber: -1,
      page: {
        // 当前页数
        pageNo: 1,
        // 每页默认显示条数
        pageSize: 10,
        // 总条数
        total: 0,
      },
    }
  },
  computed: {
    nowAdd() {
      return this.$store.state.common.nowAdd
    },
  },
  watch: {
    nowAdd: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          setTimeout(() => {
            this.dialogStatus = '新增'
            this.dialogAddVisible = true
          }, 1000)
        }
      },
    },
  },
  destroyed() {
    this.$store.commit('handleNowAdd', false)
    this.$bus.off('clickMenu')
    this.$bus.off('handleTurn')
  },
  mounted() {
    this.handeleSearchList()
    this.$bus.on('clickMenu', content => {
      this.isLoading = true
      this.$refs.multipleTables.clearSort()
      this.ruleForm.fliterTable = ''
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      this.handeleSearchList()
    })
    this.$bus.on('handleTurn', content => {
      this.dialogPortCoverageVisible = false
      this.isGangShow = false
    })

    this.handleInputClick = debounce(this.handleInputClick, 500)
  },
  methods: {
    //新增
    handleAddClick() {
      this.dialogAddVisible = true
      this.dialogStatus = '新增'
    },
    //列表行
    handleCurrentChange(row) {
      this.tablesRow = row
      this.dialogAddVisible = true
      this.dialogStatus = '编辑'
    },
    //格式化"网站显示"
    getFormatPortFlag(row) {
      const { polFlag, podFlag } = row
      const temp = [
        {
          label: 'POL',
          value: polFlag,
        },
        {
          label: 'POD',
          value: podFlag,
        },
      ].filter(flag => flag.value)
      return temp.map(flag => flag.label).join(', ')
    },
    //输入查询列表
    handleInputClick(value) {
      // document.querySelector(".loading").style.height = this.$refs.basicPortContent.getBoundingClientRect().height + 150 + 'px';
      // document.querySelector(".loading").style.position = 'absolute'
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      this.isLoading = true
      this.$refs.multipleTables.clearSort()
      this.$axios
        .get(
          this.commonJs.localUrl +
            `/schedules/port/query?pageNumber=${this.page.pageNo}&pageSize=${this.page.pageSize}&searchStr=${value}`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        .then(res => {
          if (res.data.status == 1) {
            this.tableData = res.data.content
            this.$refs.refPagination.page.total = res.data.total
            this.$refs.refPagination.changeValue()
            this.isLoading = false
            for (let i = 0; i < res.data.content.length; i++) {
              if (res.data.content[i].portCoverage.indexOf('/') !== -1) {
                var a = res.data.content[i].portCoverage.split('/')
                res.data.content[i].portCoverageNumber = a[0] / a[1]
              } else {
                res.data.content[i].portCoverageNumber = parseFloat(
                  res.data.content[i].portCoverage
                )
              }
            }
          } else if (res.data.status == 0) {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
            // this.isLoading = false;
          }
        })
        .finally(() => (this.isLoading = false))
    },
    //查询列表
    handeleSearchList(newOrAdd) {
      this.isLoading = true
      this.$refs.multipleTables.clearSort()
      if (newOrAdd) {
        if (
          Math.ceil(this.tableData.length / this.page.pageSize) <
          this.page.pageNo
        ) {
          this.page.pageNo = 1
          this.pageNumber = 1
        }
      }
      this.$axios
        .get(
          this.commonJs.localUrl +
            `/schedules/port/query?pageNumber=${this.page.pageNo}&pageSize=${this.page.pageSize}&searchStr=${this.ruleForm.fliterTable}`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        .then(res => {
          if (res.data.status == 1) {
            this.tableData = res.data.content
            for (let i = 0; i < res.data.content.length; i++) {
              if (res.data.content[i].portCoverage.indexOf('/') !== -1) {
                var a = res.data.content[i].portCoverage.split('/')
                res.data.content[i].portCoverageNumber = a[0] / a[1]
              } else {
                res.data.content[i].portCoverageNumber = parseFloat(
                  res.data.content[i].portCoverage
                )
              }
            }
            if (this.$refs.refPagination) {
              this.$refs.refPagination.page.total = res.data.total
              this.$refs.refPagination.changeValue()
            }
            // let from = (this.page.pageNo - 1)  *  this.page.pageSize;
            // let to = this.page.pageNo * this.page.pageSize;
            // this.tableDataEnd = [];
            // for (let i = from; i < to; i++) {
            //     if (this.tableData[i]) {
            //         this.tableDataEnd.push(this.tableData[i]);
            //     }
            // }
            this.isLoading = false
          } else if (res.data.status == 0) {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
            // this.isLoading = false;
          }
        })
    },
    // tabList(params,list){
    //     let from = (params.pageNo - 1) *  params.pageSize;
    //     let to = params.pageNo * params.pageSize;
    //     this.tableDataEnd = [];
    //     for (let i = from; i < to; i++) {
    //         if (list[i]) {
    //             this.tableDataEnd.push(list[i]);
    //         }
    //     }
    // },
    //给分页传的属性
    handleChange(params) {
      this.isLoading = true
      this.page.pageSize = params.pageSize
      this.page.pageNo = params.pageNo
      // this.tabList(params,this.tableData);
      this.handeleSearchList()
      this.pageNumber = -1
    },
    //表格的斑马线
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1
      if (index % 2 !== 0) {
        return 'warning-row'
      }
    },
    //港口覆盖率
    handlePortCoverageClick(index, row) {
      this.dialogPortCoverageVisible = true
      this.tableCoverageRow = row
    },
    //子组件传来的值
    handleStatus(data) {
      if (data === 1 || data.status === 1) {
        // this.isLoading = true;
        this.page.pageNo = 1
        this.pageNumber = 1
        this.dialogAddVisible = false
        this.handeleSearchList(data)
      }
    },
    handleClose() {
      // this.isLoading = true;
      this.dialogAddVisible = false
      // this.handeleSearchList();
      this.$store.commit('handleNowAdd', false)
      // this.reload();
    },
    handlePortCoverageClose() {
      this.dialogPortCoverageVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-table .cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep.el-table .caret-wrapper {
  height: 23px;
}

::v-deep.el-table .sort-caret.ascending {
  top: 0px;
}

::v-deep.el-table .sort-caret.descending {
  bottom: 1px;
}

.tablePage ::v-deep.el-icon-arrow-down::before {
  color: red;
  display: none;
  margin-left: -10px;
  height: 0;
}

::v-deep.el-table__column-filter-trigger {
  width: 0;
  height: 0;
}

.lr {
  float: right;
}

.lf {
  float: left;
}

.clickColor {
  background-color: #ff9000;
  color: #fff;
  padding: 9px 35px;
}

.searhContent {
}

.basicPortContent {
  position: relative;
  overflow: hidden;
}

::v-deep .el-form-item__content {
  margin: 0 !important;
}

::v-deep.el-table th,
::v-deep.el-table tr {
  height: 30px;
}

::v-deep.el-table th {
  height: 30px;
  padding: 0;
}

::v-deep.el-table .warning-row {
  background: rgba(241, 245, 247, 1) !important;
}

::v-deep.el-table .warning-row:hover {
  background: rgba(241, 245, 247, 1);
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
  // background-color:transparent;
  // background-color:#3bb0da50;
  // cursor: pointer;
}

::v-deep .refPagination input {
  width: 100px !important;
}

.refPagination {
  width: 100%;
  background-color: #fff;
  // float: right !important;
}

.portCoverages {
  color: #3bafda;
  cursor: pointer;
}

::v-deep.el-dialog__body {
  padding: 10px !important;
}

::v-deep.el-table__empty-text {
  width: 100%;
}
</style>
